import React from 'react';

export const NoWrap = (props: React.ComponentPropsWithoutRef<any>) => props.children;
